import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './cons-member-document-type.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const ConsMemberDocumentTypeDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const consMemberDocumentTypeEntity = useAppSelector(state => state.consMemberDocumentType.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="consMemberDocumentTypeDetailsHeading">
          <Translate contentKey="almobadaraMasterDataApp.consMemberDocumentType.detail.title">ConsMemberDocumentType</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{consMemberDocumentTypeEntity.id}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="almobadaraMasterDataApp.consMemberDocumentType.name">Name</Translate>
            </span>
          </dt>
          <dd>{consMemberDocumentTypeEntity.name}</dd>
          <dt>
            <span id="folderName">
              <Translate contentKey="almobadaraMasterDataApp.consMemberDocumentType.folderName">Folder Name</Translate>
            </span>
          </dt>
          <dd>{consMemberDocumentTypeEntity.folderName}</dd>
          <dt>
            <span id="status">
              <Translate contentKey="almobadaraMasterDataApp.consMemberDocumentType.status">Status</Translate>
            </span>
          </dt>
          <dd>{consMemberDocumentTypeEntity.status}</dd>
        </dl>
        <Button tag={Link} to="/cons-member-document-type" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/cons-member-document-type/${consMemberDocumentTypeEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ConsMemberDocumentTypeDetail;
